import { render, staticRenderFns } from "./linkedprofessionalarea.vue?vue&type=template&id=40df5c2a"
import script from "./linkedprofessionalarea.vue?vue&type=script&lang=ts"
export * from "./linkedprofessionalarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports